// Define role constant for better maintainability
const NKO_ROLES = ['PIC Kinerja', 'EPI Admin', 'Approval Kinerja', 'Super Admin', 'Admin', 'Viewer'];

export default [
  {
    path: '/nko/dashboard',
    name: 'nko-dashboard',
    component: () => import(/* webpackChunkName: "nko-dashboard" */ '@/view/nko/dashboard/index.vue'),
    meta: { auth: true, roles: NKO_ROLES },
  },
  {
    path: '/nko/entitas',
    name: 'nko-entitas',
    component: () => import(/* webpackChunkName: "nko-entitas" */ '@/view/nko/entitas/index.vue'),
    meta: { auth: true, roles: NKO_ROLES },
  },
  {
    path: '/nko/kontrak',
    name: 'nko-kontrak',
    component: () => import(/* webpackChunkName: "nko-kontrak" */ '@/view/nko/kontrak/index.vue'),
    meta: { auth: true, roles: NKO_ROLES },
  },
  {
    path: '/nko/rekap',
    name: 'nko-rekap',
    component: () => import(/* webpackChunkName: "nko-rekap" */ '@/view/nko/rekap/index.vue'),
    meta: { auth: true, roles: NKO_ROLES },
  },
  {
    path: '/nko/monitoring',
    name: 'nko-monitoring',
    component: () => import(/* webpackChunkName: "nko-monitoring" */ '@/view/nko/monitoring/index.vue'),
    meta: { auth: true, roles: NKO_ROLES },
  },
  {
    path: '/nko-kontrak-add/:month/:year',
    name: 'nko-kontrak-add',
    component: () => import(/* webpackChunkName: "nko-kontrak-add" */ '@/view/nko/kontrak/add.vue'),
    meta: { auth: true, roles: NKO_ROLES },
  },
  {
    path: '/nko-kontrak-edit/:id/:month/:year',
    name: 'nko-kontrak-edit',
    component: () => import(/* webpackChunkName: "nko-kontrak-edit" */ '@/view/nko/kontrak/edit.vue'),
    meta: { auth: true, roles: NKO_ROLES },
  },
  {
    path: '/nko-kontrak-add-kpi/:id/:month/:year/:entitas',
    name: 'nko-kontrak-add-kpi',
    component: () => import(/* webpackChunkName: "nko-kontrak-add-kpi" */ '@/view/nko/kontrak/add-kpi.vue'),
    meta: { auth: true, roles: NKO_ROLES },
  },
  {
    path: '/nko-kontrak-edit-kpi/:id/:month/:year',
    name: 'nko-kontrak-edit-kpi',
    component: () => import(/* webpackChunkName: "nko-kontrak-edit-kpi" */ '@/view/nko/kontrak/edit-kpi.vue'),
    meta: { auth: true, roles: NKO_ROLES },
  },
  {
    path: '/nko-kontrak-add-target/:id/:month/:year',
    name: 'nko-kontrak-add-target',
    component: () => import(/* webpackChunkName: "nko-kontrak-add-target" */ '@/view/nko/kontrak/add-target.vue'),
    meta: { auth: true, roles: NKO_ROLES },
  },
  {
    path: '/nko-kontrak-detail-target/:id/:month/:year',
    name: 'nko-kontrak-detail-target',
    component: () => import(/* webpackChunkName: "nko-kontrak-detail-target" */ '@/view/nko/kontrak/detail-target.vue'),
    meta: { auth: true, roles: NKO_ROLES },
  },
  {
    path: '/nko-kontrak-edit-target/:id',
    name: 'nko-kontrak-edit-target',
    component: () => import(/* webpackChunkName: "nko-kontrak-edit-target" */ '@/view/nko/kontrak/edit-target.vue'),
    meta: { auth: true, roles: NKO_ROLES },
  },
  {
    path: '/nko-rekap-add-realisasi/:id/:month/:year',
    name: 'nko-rekap-add-realisasi',
    component: () => import(/* webpackChunkName: "nko-rekap-add-realisasi" */ '@/view/nko/rekap/add-realisasi.vue'),
    meta: { auth: true, roles: NKO_ROLES },
  },
  {
    path: '/nko-rekap-detail-realisasi/:id/:month/:year',
    name: 'nko-rekap-detail-realisasi',
    component: () =>
      import(/* webpackChunkName: "nko-rekap-detail-realisasi" */ '@/view/nko/rekap/detail-realisasi.vue'),
    meta: { auth: true, roles: NKO_ROLES },
  },
  {
    path: '/nko-rekap-edit-realisasi/:id',
    name: 'nko-rekap-edit-realisasi',
    component: () => import(/* webpackChunkName: "nko-rekap-edit-realisasi" */ '@/view/nko/rekap/edit-realisasi.vue'),
    meta: { auth: true, roles: NKO_ROLES },
  },
  {
    path: '/nko-rekap-add-verifikasi/:id/:month/:year',
    name: 'nko-rekap-add-verifikasi',
    component: () => import(/* webpackChunkName: "nko-rekap-add-verifikasi" */ '@/view/nko/rekap/add-verifikasi.vue'),
    meta: { auth: true, roles: NKO_ROLES },
  },
  {
    path: '/nko-rekap-edit-verifikasi/:id',
    name: 'nko-rekap-edit-verifikasi',
    component: () => import(/* webpackChunkName: "nko-rekap-edit-verifikasi" */ '@/view/nko/rekap/edit-verifikasi.vue'),
    meta: { auth: true, roles: NKO_ROLES },
  },
  {
    path: '/nko-rekap-upload',
    name: 'nko-rekap-upload',
    component: () => import(/* webpackChunkName: "nko-rekap-upload" */ '@/view/nko/rekap/upload-file.vue'),
    meta: { auth: true, roles: NKO_ROLES },
  },
];
